/* eslint-disable @typescript-eslint/no-explicit-any */
import BaseApiService from '../baseApi.service';

export default class ChangelogService extends BaseApiService {
  readonly basePath: string = 'changelog/v1';
  constructor(props = null) {
    super(props);
  }
}
